import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { fetchAuthSession } from '@aws-amplify/auth';
import {
  OAuthModuleConfig,
  OAuthResourceServerErrorHandler,
  OAuthService,
} from 'angular-oauth2-oidc';
import { catchError, from, switchMap, throwError } from 'rxjs';

export const authenticationInterceptor: HttpInterceptorFn = (
  req,
  next
) => {
  return from(fetchAuthSession()).pipe(
    switchMap((session) => {
      const token = session.tokens?.accessToken?.toString();

      if (token) {
        const headers = req.headers.set('Authorization', `Bearer ${token}`);
        req = req.clone({ headers });
      }

      return next(req);
    })
  );
};
